import { Alert, Snackbar } from "@mui/material";
import { useNotificationStore } from "../store/notificationStore";
import { useSettingsStore } from "../store/settingsStore";

export function NotificationCenter() {
  const queue = useNotificationStore((state) => state.queue);
  const dequeue = useNotificationStore((state) => state.dequeue);
  const current = queue[0];
  const autoDismiss = useSettingsStore((state) => state.notificationsAutoDismiss);
  const defaultDuration = useSettingsStore((state) => state.notificationsDurationMs);

  const handleClose = () => {
    if (current) {
      dequeue();
    }
  };

  const autoHideDuration = autoDismiss ? current?.autoHideDuration ?? defaultDuration : null;

  return current ? (
    <Snackbar
      open
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={current.severity} sx={{ width: "100%" }}>
        {current.message}
      </Alert>
    </Snackbar>
  ) : null;
}
